module.exports = __webpack_public_path__ + "assets/img/tx101s_1.35cf000e.jpg";